import { useState, useEffect } from 'react';
import authService from '../services/authService';

export const useAuthToken = () => {
  const [token, setToken] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initToken = async () => {
      setIsLoading(true);
      
      try {
        // First check if we have a valid token format in localStorage
        const existingToken = authService.getToken();
        
        if (existingToken && !authService.isValidTokenFormat(existingToken)) {
          console.log('[AUTH] Invalid token format detected, clearing and getting new token');
          await authService.handleCorruptedToken();
        }
        
        const currentToken = await authService.refreshTokenIfNeeded();
        setToken(currentToken);
        setRetryCount(0); // Reset retry count on success
      } catch (error) {
        console.error('Failed to get auth token:', error);
        
        // If this is the first failure, try to force refresh the token
        if (retryCount === 0) {
          console.log('[AUTH] Attempting to force refresh token...');
          setRetryCount(1);
          try {
            const newToken = await authService.forceRefreshToken();
            setToken(newToken);
          } catch (refreshError) {
            console.error('Failed to force refresh token:', refreshError);
            setToken(null);
          }
        } else {
          setToken(null);
        }
      } finally {
        setIsLoading(false);
      }
    };

    initToken();
  }, [retryCount]);

  return { token, isLoading };
};